import { render, staticRenderFns } from "./select-view.vue?vue&type=template&id=b203af3e"
import script from "./select-view.vue?vue&type=script&lang=js"
export * from "./select-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports